<div class="ca-badge">
  @if (displayHeader) {
    <rc-badge variant="small"></rc-badge>
    <p class="ca-badge__text">{{ 'label_clinical-alliance' | translateKey | uppercase }}</p>
  }
</div>
